import { __awaiter, __generator, __assign, __rest } from '../node_modules/tslib/tslib.es6.js';
import _get from 'lodash/get';
import mixpanel from 'mixpanel-browser';
import queryString from 'qs';
import BrandclubStoreConfigUtils from '../utils/brandclubStoreConfigUtils.js';
import { AnalyticsTrackingEvent } from './events.js';
import { enableDebug, track as track$1 } from './externalTracking.js';

var deferredPromise = function () {
    var resolve = function () { return void 0; };
    var reject = function () { return void 0; };
    var isDone = false;
    var p = new Promise(function (r, e) {
        resolve = function (v) {
            isDone = true;
            r(v);
        };
        reject = function (err) {
            isDone = true;
            e(err);
        };
    });
    return { p: p, resolve: resolve, reject: reject, isDone: function () { return isDone; } };
};
var isInitialized = false;
var __PROD__ = BrandclubStoreConfigUtils.getAppStage() === 'prod';
var DEBUG = !__PROD__ && false;
if (DEBUG) {
    enableDebug();
}
var currentVisitorTracking = deferredPromise();
function setCurrentVisitorTracking(visitorTracking) {
    if (visitorTracking && visitorTracking.uniqueVisitorId) {
        if (DEBUG) {
            // eslint-disable-next-line no-console
            console.log('[DEBUG] resolving ', visitorTracking);
        }
        currentVisitorTracking.resolve(visitorTracking);
    }
}
function track(eventName, eventProps, options) {
    return __awaiter(this, void 0, void 0, function () {
        var location, params, pathName, eventNameForService, _a, brandPixels, rest, paramsForService, e_1, visitorTracking_1, e_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    location = window.location;
                    params = queryString.parse(location.search, {
                        ignoreQueryPrefix: true,
                        arrayLimit: 100,
                    });
                    pathName = _get(location.pathname.split('/'), '1');
                    eventNameForService = "".concat(eventName);
                    _a = eventProps || {}, brandPixels = _a.brandPixels, rest = __rest(_a, ["brandPixels"]);
                    paramsForService = __assign(__assign(__assign({}, rest), params), { pathName: pathName === null || pathName === void 0 ? void 0 : pathName.toLowerCase(), referrer: document.referrer, retailerId: (rest === null || rest === void 0 ? void 0 : rest.retailerId) || params.rid });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, track$1(eventNameForService, paramsForService, brandPixels)];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    console.error("Error sending event (".concat(eventNameForService, ") to external tracking: ").concat(e_1.message));
                    return [3 /*break*/, 4];
                case 4:
                    if (DEBUG) {
                        // eslint-disable-next-line no-console
                        console.log("[DEBUG] sending '".concat(eventNameForService, "' with params: "), paramsForService);
                    }
                    _b.label = 5;
                case 5:
                    _b.trys.push([5, 9, , 10]);
                    if (!isInitialized) {
                        initializeMixpanel();
                    }
                    if (!isInitialized) return [3 /*break*/, 7];
                    if (DEBUG) {
                        // eslint-disable-next-line no-console
                        console.log("[DEBUG] Sending ".concat(eventNameForService, " to Mixpanel"));
                    }
                    return [4 /*yield*/, currentVisitorTracking.p];
                case 6:
                    visitorTracking_1 = _b.sent();
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var _a, _b, _c, _d, _e, _f, _g;
                            try {
                                if (visitorTracking_1 && visitorTracking_1.fingerprintResult) {
                                    mixpanel.track(eventNameForService, __assign(__assign({}, paramsForService), { ipAddress: visitorTracking_1.fingerprintResult.ip, timeZone: (_a = visitorTracking_1.fingerprintResult.ipLocation) === null || _a === void 0 ? void 0 : _a.timezone, location: {
                                            city: (_b = visitorTracking_1.fingerprintResult.ipLocation) === null || _b === void 0 ? void 0 : _b.city,
                                            country: (_d = (_c = visitorTracking_1.fingerprintResult.ipLocation) === null || _c === void 0 ? void 0 : _c.country) === null || _d === void 0 ? void 0 : _d.code,
                                            latitude: (_e = visitorTracking_1.fingerprintResult.ipLocation) === null || _e === void 0 ? void 0 : _e.latitude,
                                            longitude: (_f = visitorTracking_1.fingerprintResult.ipLocation) === null || _f === void 0 ? void 0 : _f.longitude,
                                            postalCode: (_g = visitorTracking_1.fingerprintResult.ipLocation) === null || _g === void 0 ? void 0 : _g.postalCode, // The postal code or zip code of the endpoint.
                                        } }), {
                                        send_immediately: options === null || options === void 0 ? void 0 : options.sendImmediately,
                                    }, function (response) {
                                        if (response === 0 || (response === null || response === void 0 ? void 0 : response.status) === 0) {
                                            reject(new Error('Mixpanel event not sent'));
                                        }
                                        else {
                                            resolve({ eventName: eventNameForService, eventParams: paramsForService });
                                        }
                                    });
                                }
                                else {
                                    mixpanel.track(eventNameForService, paramsForService, {
                                        send_immediately: options === null || options === void 0 ? void 0 : options.sendImmediately,
                                    }, function (response) {
                                        if (response === 0 || (response === null || response === void 0 ? void 0 : response.status) === 0) {
                                            reject(new Error('Mixpanel event not sent'));
                                        }
                                        else {
                                            resolve({ eventName: eventNameForService, eventParams: paramsForService });
                                        }
                                    });
                                }
                            }
                            catch (e) {
                                reject(e);
                            }
                        })];
                case 7:
                    console.error('mixpanel not initialized');
                    _b.label = 8;
                case 8: return [3 /*break*/, 10];
                case 9:
                    e_2 = _b.sent();
                    console.error("Error sending event (".concat(eventNameForService, ") to Mixpanel: ").concat(e_2.message));
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    });
}
/**
 *  Logs to mixpanel if in prod, but warns to the console if not.
 *  @param msg a description of the event to be logged
 *  @param obj an optional object of related data to log with the message
 *  @param eventName an optional name for the event, defaults to 'warning'
 * */
function warn(msg, obj, eventName) {
    if (eventName === void 0) { eventName = AnalyticsTrackingEvent.WARNING; }
    if (__PROD__) {
        track(eventName, obj || {});
    }
    else if (obj) {
        console.warn(msg, obj);
    }
    else {
        console.warn(msg);
    }
}
/**
 *  Logs to mixpanel if in prod, but errors in the console if not.
 *  @param msg a description of the event to be logged
 *  @param obj an optional object of related data to log with the message
 *  @param eventName an optional name for the Mixpanel event, defaults to 'error'
 * */
function error(msg, obj, eventName) {
    if (eventName === void 0) { eventName = AnalyticsTrackingEvent.ERROR; }
    if (__PROD__) {
        track(eventName, obj ? __assign(__assign({}, obj), { message: msg }) : { message: msg });
    }
    else if (obj) {
        console.error(msg, obj);
    }
    else {
        console.error(msg);
    }
}
/**
 * This function should be called when the application encounters an untenable state and cannot continue.  It will throw
 * an `Error` with the provided message and log the provided metadata object to the console if provided.  If in production,
 * it will trigger a Mixpanel event for the error and supply the provided metadata.
 *
 * @param msg a description of the error or unhandleable event that occurred
 * @param obj an optional object of related data to log with the message
 * @param eventName an optional name for the Mixpanel event, defaults to 'return panic'
 */
function panic(msg, obj, eventName) {
    if (eventName === void 0) { eventName = AnalyticsTrackingEvent.RETURN_PANIC; }
    if (__PROD__) {
        track(eventName, obj ? __assign(__assign({}, obj), { msg: msg }) : { msg: msg });
    }
    else if (obj) {
        console.error(msg, obj);
    }
    throw new Error(msg);
}
var getMixpanelApiHost = function () {
    var _a;
    var nodeEnv = ((_a = import.meta.env) === null || _a === void 0 ? void 0 : _a.MODE) || process.env.NODE_ENV;
    if (nodeEnv === 'development') {
        return undefined; // will default to normal mixpanel host
    }
    return window.location.origin;
};
function initializeMixpanel(domainOverride) {
    if (__PROD__) {
        mixpanel.init('5f5add70c60a83f55ad7ba6d75faf5db', {
            ignore_dnt: true,
            api_host: domainOverride || getMixpanelApiHost(),
        });
    }
    else {
        mixpanel.init('cde1743169537cd47bc24fe7f0ee14b0', {
            ignore_dnt: true,
            api_host: domainOverride || getMixpanelApiHost(),
        });
    }
    isInitialized = true;
}
function isMixpanelInitialized() {
    return isInitialized;
}
function setMixpanelUserIdentity(visitorTracking, user) {
    if (user) {
        var firstName = user.given_name, lastName = user.family_name, email = user.email, userId = user.userId;
        mixpanel.identify(userId);
        mixpanel.register({
            FirstName: firstName,
            LastName: lastName,
            Email: email,
            UniqueVisitorId: visitorTracking === null || visitorTracking === void 0 ? void 0 : visitorTracking.uniqueVisitorId,
        });
        mixpanel.people.set({
            $first_name: firstName,
            $last_name: lastName,
            $email: email,
        });
    }
    else if (visitorTracking === null || visitorTracking === void 0 ? void 0 : visitorTracking.uniqueVisitorId) {
        mixpanel.identify(visitorTracking === null || visitorTracking === void 0 ? void 0 : visitorTracking.uniqueVisitorId);
    }
}
/**
 * Used to mark potentially dead code for future deletion. When code could potentially be dead, but you aren't sure,
 * put a tombstone in it and check the logs if it was ever hit. This helps make dead code deletion safer.
 * Idea taken from https://www.bugsnag.com/blog/javascript-refactoring-with-bugsnag-and-tombstones
 *
 * @param msg a custom message for mixpanel, should include the file and line (e.g. operations.ts:113)
 * @param obj an optional object to log with the message.
 */
function tombstone(msg, obj) {
    if (obj === void 0) { obj = {}; }
    track("tombstone: ".concat(msg), obj);
}
function trackRouteChange(previousLocation, nextLocation) {
    var params = queryString.parse(nextLocation.search, {
        ignoreQueryPrefix: true,
        arrayLimit: 100,
    });
    track(AnalyticsTrackingEvent.PAGE_VIEW, __assign(__assign({}, params), { currentUrl: nextLocation.pathname, previousUrl: previousLocation.pathname }));
}
var trackError = function (url, err) {
    track(AnalyticsTrackingEvent.ERROR_PAGE, {
        url: url,
        message: err.message,
        backtrace: err.stack || '',
        lineNumber: err.lineNumber,
    });
};

export { deferredPromise, error, initializeMixpanel, isMixpanelInitialized, panic, setCurrentVisitorTracking, setMixpanelUserIdentity, tombstone, track, trackError, trackRouteChange, warn };
//# sourceMappingURL=AnalyticsService.js.map
